<!-- Jobs Icon + Dropdown -->
<div class="job-status-icon-wrapper" ngbDropdown #jobDropdown="ngbDropdown" display="dynamic" placement="bottom-end"
  (openChange)="onDropdownToggle($event)">

  <!-- Icon Button with Badge -->
  <div role="button" class="d-flex align-content-center rounded-circle p-2 position-relative" ngbDropdownToggle
    id="jobStatusDropdown" aria-label="Jobs">
    <i class="bi bi-arrow-repeat text-center" style="width: 1.5rem; height: 1.5rem;"
      [class.spin]="inProgressCount > 0"></i>
    <span *ngIf="inProgressCount > 0"
      class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
      style="font-size: 0.6rem; padding: 0.2rem 0.4rem;">
      {{ inProgressCount }}
    </span>
    <span *ngIf="inProgressCount === 0 && isLatestJobPreviewReady"
      class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-success"
      style="font-size: 0.55rem; padding: 0.15rem 0.3rem;">
      <i class="bi bi-check"></i>
    </span>
  </div>

  <!-- Dropdown Panel -->
  <div ngbDropdownMenu aria-labelledby="jobStatusDropdown" class="job-status-dropdown dropdown-menu-end p-0">
    <div class="job-panel" style="width: 360px;">

      <!-- Header -->
      <div class="d-flex align-items-center justify-content-between px-3 py-2 border-bottom bg-light">
        <span class="fw-bold small text-dark"><i class="bi bi-layers me-1"></i>Jobs</span>
      </div>

      <!-- Tabs -->
      <div class="d-flex border-bottom">
        <button class="tab-btn flex-grow-1" [class.active]="activeTab === 'in-progress'"
          (click)="setTab('in-progress')">
          Latest Job
          <span *ngIf="inProgressCount > 0" class="tab-badge">{{ inProgressCount }}</span>
        </button>
        <button class="tab-btn flex-grow-1" [class.active]="activeTab === 'list'" (click)="setTab('list')">
          List
          <span *ngIf="jobList.length > 0" class="tab-badge muted">{{ jobList.length }}</span>
        </button>
      </div>

      <!-- ═══ In Progress Tab ═══ -->
      <div class="overflow-y-auto" style="max-height: 340px;" *ngIf="activeTab === 'in-progress'">

        <!-- In progress -->
        <div *ngIf="currentJob && isInProgress(currentJob.status)" class="p-3">
          <div class="d-flex align-items-center gap-3">
            <div class="spinner-border spinner-border-sm text-secondary flex-shrink-0" role="status"></div>
            <div class="flex-grow-1 min-w-0">
              <div class="fw-semibold text-dark" style="font-size: 0.8rem;">{{ currentJob.stage || 'Processing' }}</div>
              <div class="text-muted text-truncate" style="font-size: 0.68rem;">
                <span *ngIf="currentJob.categoryDisplayName" class="me-1">{{ currentJob.categoryDisplayName }}
                  &middot;</span>{{ currentJob.message }}
              </div>
            </div>
            <div class="flex-shrink-0 d-flex align-items-center gap-2">
              <span class="fw-bold text-secondary" style="font-size: 0.75rem;">{{ currentJob.progress }}%</span>
              <button class="btn btn-link text-danger p-0" title="Cancel job" (click)="cancelJob(currentJob, $event)">
                <i class="bi bi-x-circle" style="font-size: 1rem;"></i>
              </button>
            </div>
          </div>
          <div class="progress mt-2" style="height: 4px;">
            <div class="progress-bar bg-secondary" role="progressbar" [style.width.%]="currentJob.progress"></div>
          </div>
        </div>

        <!-- Preview ready -->
        <div *ngIf="currentJob && isPreviewReady(currentJob.status)" class="p-3">
          <div class="d-flex align-items-center gap-3">
            <i class="bi bi-eye-fill text-primary fs-5 flex-shrink-0"></i>
            <div class="flex-grow-1 min-w-0">
              <div class="fw-semibold text-dark" style="font-size: 0.8rem;">Preview Ready</div>
              <div class="text-muted" style="font-size: 0.68rem;">
                <span *ngIf="currentJob.categoryDisplayName">{{ currentJob.categoryDisplayName }} &middot; </span>{{
                currentJob.totalRows }} rows &middot; {{ currentJob.message }}
              </div>
            </div>
            <span class="badge rounded-pill badge-preview-ready" style="font-size: 0.6rem;">Ready</span>
          </div>
          <button class="btn btn-secondary btn-sm text-white w-100 mt-3 fw-semibold" (click)="viewPreview(currentJob)">
            <i class="bi bi-table me-1"></i>Review &amp; Validate
          </button>
        </div>

        <!-- Committed -->
        <div *ngIf="currentJob && isCompleted(currentJob.status)" class="p-3">
          <div class="d-flex align-items-center gap-3">
            <i class="bi bi-check-circle-fill text-success fs-5 flex-shrink-0"></i>
            <div class="flex-grow-1 min-w-0">
              <div class="fw-semibold text-dark" style="font-size: 0.8rem;">Committed</div>
              <div class="text-muted" style="font-size: 0.68rem;">{{ currentJob.message }}</div>
            </div>
            <span class="badge rounded-pill badge-completed" style="font-size: 0.6rem;">Done</span>
          </div>
        </div>

        <!-- Failed -->
        <div *ngIf="currentJob && isFailed(currentJob.status)" class="p-3">
          <div class="d-flex align-items-center gap-3">
            <i class="bi bi-exclamation-circle-fill text-danger fs-5 flex-shrink-0"></i>
            <div class="flex-grow-1 min-w-0">
              <div class="fw-semibold text-dark" style="font-size: 0.8rem;">Failed</div>
              <div class="text-muted" style="font-size: 0.68rem;">{{ currentJob.message }}</div>
            </div>
            <span class="badge rounded-pill badge-failed" style="font-size: 0.6rem;">Failed</span>
          </div>
        </div>

        <!-- Cancelled -->
        <div *ngIf="currentJob && isCancelled(currentJob.status)" class="p-3">
          <div class="d-flex align-items-center gap-3">
            <i class="bi bi-slash-circle-fill text-muted fs-5 flex-shrink-0"></i>
            <div class="flex-grow-1 min-w-0">
              <div class="fw-semibold text-dark" style="font-size: 0.8rem;">Cancelled</div>
              <div class="text-muted" style="font-size: 0.68rem;">{{ currentJob.message }}</div>
            </div>
            <span class="badge rounded-pill badge-cancelled" style="font-size: 0.6rem;">Cancelled</span>
          </div>
        </div>

        <!-- No job -->
        <div *ngIf="!currentJob" class="d-flex flex-column align-items-center justify-content-center py-4 text-muted">
          <i class="bi bi-check-circle fs-2 mb-2 opacity-50"></i>
          <div class="small">No jobs in progress</div>
        </div>
      </div>

      <!-- ═══ List Tab ═══ -->
      <div class="overflow-y-auto" style="max-height: 340px;" *ngIf="activeTab === 'list'">

        <div *ngIf="listLoading" class="d-flex justify-content-center py-4">
          <div class="spinner-border spinner-border-sm text-secondary" role="status"></div>
        </div>

        <div *ngIf="!listLoading">
          <div *ngFor="let job of jobList; trackBy: trackByJobId"
            class="job-item d-flex align-items-center gap-3 px-3 py-2 border-bottom">

            <!-- Status icon -->
            <div class="flex-shrink-0">
              <div *ngIf="isInProgress(job.status)" class="spinner-border spinner-border-sm text-secondary"
                role="status"></div>
              <i *ngIf="isPreviewReady(job.status)" class="bi bi-eye-fill text-primary"></i>
              <i *ngIf="isCompleted(job.status)" class="bi bi-check-circle-fill text-success"></i>
              <i *ngIf="isFailed(job.status)" class="bi bi-exclamation-circle-fill text-danger"></i>
              <i *ngIf="isCancelled(job.status)" class="bi bi-slash-circle-fill text-muted"></i>
            </div>

            <!-- Info -->
            <div class="flex-grow-1 min-w-0">
              <div class="d-flex align-items-center gap-2">
                <span class="badge rounded-pill" style="font-size: 0.55rem;"
                  [ngClass]="getStatusBadgeClass(job.status)">
                  {{ getStatusLabel(job.status) }}
                </span>
                <span *ngIf="job.categoryDisplayName" class="text-muted" style="font-size: 0.6rem;">{{
                  job.categoryDisplayName }}</span>
                <span *ngIf="job.totalRows" class="text-muted" style="font-size: 0.6rem;">{{ job.totalRows }}
                  rows</span>
              </div>
              <div class="text-muted text-truncate" style="font-size: 0.65rem;">
                {{ job.fileName }}
              </div>
              <div class="text-muted text-truncate" style="font-size: 0.6rem;" *ngIf="job.createdAt">
                {{ job.createdAt | date:'short' }}
              </div>
              <div class="progress mt-1" style="height: 2px;" *ngIf="isInProgress(job.status)">
                <div class="progress-bar bg-secondary" role="progressbar" [style.width.%]="job.progress"></div>
              </div>
            </div>

            <!-- Actions -->
            <div class="flex-shrink-0 d-flex align-items-center gap-1">
              <button *ngIf="isInProgress(job.status) || isPreviewReady(job.status)"
                class="btn btn-link text-danger p-0" title="Cancel" (click)="cancelJob(job, $event)">
                <i class="bi bi-x-circle" style="font-size: 0.85rem;"></i>
              </button>
              <button *ngIf="isPreviewReady(job.status)" class="badge rounded-pill badge-review-btn border-0"
                style="font-size: 0.6rem; cursor: pointer;" (click)="viewPreview(job)">
                <i class="bi bi-eye me-1"></i>Review
              </button>
            </div>
          </div>

          <div *ngIf="jobList.length === 0"
            class="d-flex flex-column align-items-center justify-content-center py-4 text-muted">
            <i class="bi bi-inbox fs-2 mb-2 opacity-50"></i>
            <div class="small">No upload jobs yet</div>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>